<template>
  <!-- 企業検診判定依頼詳細 -->
  <div id="KenshinJudgmentOrderDetailList">
    <div id="container">
      <div class="labelTitle lable">企業検診 判定依頼詳細</div>
      <div style="margin-top:15px; width:100%; display:inline-block;">
        <span style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word; float:left; margin-left:20px;font-size:20px;text-align:left;">企業名：{{data.companyName}}</span>
        <b-button class="backButton is-primary" style="float:right;" v-on:click="back">戻る</b-button>
      </div>
      <div class="labelTitle lable">判定依頼内容</div>
      <div style="margin-top:10px;" :key="renderKey">
        <div class="tableScroll-area" v-if="isWP">
          <b-table
            id="kenshinJudgmentOrderDetailListTable"
            :data="data.JudgmentRequestList"
            :paginated="true"
            per-page="10"
            pagination-position="both"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="受付番号" width="120" sortable centered>
                <router-link :to="{name:'KenshinJudgmentOrderDetailone', params:{targetNumber:targetNumber, searchParams:searchParams, companyName:data.companyName, data:props.row, model:modelName, isWP:isWP, isSimonJ:isSimonJ, version: data.version}}"><a>{{props.row.receiptNumber}}</a></router-link>
              </b-table-column>
              <b-table-column field="info" label="測定情報">
                <table class="innerTable">
                  <tr>
                    <th colspan="2">社員番号</th><th colspan="2">名前</th><th>性別</th><th>生年月日</th><th>年齢</th><th>身長</th><th>体重</th><th>BMI</th>
                  </tr>
                  <tr>
                    <td colspan="2">{{props.row.employeeNumber}}</td><td colspan="2">{{props.row.name}}</td><td>{{props.row.gender}}</td><td>{{props.row.birthday}}</td><td>{{props.row.age}}</td><td>{{props.row.height}}</td><td>{{props.row.weight}}</td><td>{{props.row.bmi}}</td>
                  </tr>
                  <tr>
                    <th>検査ID</th><th>開始日</th><th>開始時間</th><th>終了日</th><th>終了時間</th><th>測定時間</th><th>睡眠時間</th><th>ODI4</th><th>RDI</th><th>AHI</th>
                  </tr>
                  <tr>
                    <td>{{props.row.inspectionId}}</td><td>{{props.row.startDate}}</td><td>{{props.row.startTime}}</td><td>{{props.row.endDate}}</td><td>{{props.row.endTime}}</td><td>{{props.row.measurementTime}}</td><td>{{props.row.sleepTime}}</td><td>{{props.row.odi4}}</td><td>{{props.row.rdi}}</td><td>{{props.row.ahi}}</td>
                  </tr>
                  <tr>
                    <th>SPO2中央</th><th>SPO2最低</th><th>脈拍平均</th><th>脈拍最低</th><th>酸素90未満</th><th>酸素88未満</th><th>酸素85未満</th><th>酸素80未満</th><th>酸素70未満</th><th>いびき40dB率</th>
                  </tr>
                  <tr>
                    <td>{{props.row.SPO2Center}}</td><td>{{props.row.SPO2Minimum}}</td><td>{{props.row.pulseAverage}}</td><td>{{props.row.pulseLowest}}</td><td>{{props.row.oxygenLess90}}</td><td>{{props.row.oxygenLess88}}</td><td>{{props.row.oxygenLess85}}</td><td>{{props.row.oxygenLess80}}</td><td>{{props.row.oxygenLess70}}</td><td>{{props.row.snoring40dBRate}}</td>
                  </tr>
                  <tr><th>セルフチェック</th></tr>
                  <tr><td>{{props.row.selfCheck}}</td></tr>
                  <tr>
                    <td colspan="10">
                      <ul class="report-list">
                        <li v-for="(report,index) in props.row.reportList" :key="index"><a @click="downloadFile(report.fileAddress, report.fileId)"><b-icon icon="paperclip" />{{report.name}}</a></li>
                      </ul>
                    </td>
                  </tr>
                </table>
              </b-table-column>
              <b-table-column field="delete" label="抽出に戻す" width="80" centered>
                <a @click="returnData(props.row.receiptNumber)">
                  <b-icon icon="file-undo-outline" size="is-medium"></b-icon>
                </a>
              </b-table-column>
            </template>
          </b-table>
        </div>
        <div class="tableScroll-area" v-else-if="isSimonJ">
          <b-table
            id="kenshinJudgmentOrderDetailListTable"
            :data="data.JudgmentRequestList"
            :paginated="true"
            per-page="10"
            pagination-position="both"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="受付番号" width="120" sortable centered>
                <router-link :to="{name:'KenshinJudgmentOrderDetailone', params:{targetNumber:targetNumber, searchParams:searchParams, companyName:data.companyName, data:props.row, model:modelName, isWP:isWP, isSimonJ:isSimonJ, version: data.version}}"><a>{{props.row.receiptNumber}}</a></router-link>
              </b-table-column>
              <b-table-column field="info" label="測定情報">
                <table class="innerTable">
                  <tr>
                    <th colspan="2">社員番号</th><th colspan="2">名前</th><th>性別</th><th>生年月日</th><th>年齢</th>
                  </tr>
                  <tr>
                    <td colspan="2">{{props.row.employeeNumber}}</td><td colspan="2">{{props.row.name}}</td><td>{{props.row.gender}}</td><td>{{props.row.birthday}}</td><td>{{props.row.age}}</td>
                  </tr>
                  <tr>
                    <th>身長</th><th>体重</th><th>BMI</th><th>患者ID</th><th>測定日</th><th>開始時刻</th><th>測定時間</th>
                  </tr>
                  <tr>
                    <td>{{props.row.height}}</td><td>{{props.row.weight}}</td><td>{{props.row.bmi}}</td><td>{{props.row.inspectionId}}</td><td>{{props.row.startDate}}</td><td>{{props.row.startTime}}</td><td>{{props.row.measurementTime}}</td>
                  </tr>
                  <tr>
                    <th>解析時間</th><th>ODI3</th><th>SPO2平均値</th><th>SPO2最低値</th><th>SPO2低下数</th><th>脈拍平均</th><th>セルフチェック</th>
                  </tr>
                  <tr>
                    <td>{{props.row.analysisTime}}</td><td>{{props.row.odi3}}</td><td>{{props.row.SPO2Center}}</td><td>{{props.row.SPO2Minimum}}</td><td>{{props.row.SPO2Declines}}</td><td>{{props.row.pulseAverage}}</td><td>{{props.row.selfCheck}}</td>
                  </tr>
                  <tr>
                    <td colspan="10">
                      <ul class="report-list">
                        <li v-for="(report,index) in props.row.reportList" :key="index"><a @click="downloadFile(report.fileAddress, report.fileId)"><b-icon icon="paperclip" />{{report.name}}</a></li>
                      </ul>
                    </td>
                  </tr>
                </table>
              </b-table-column>
              <b-table-column field="delete" label="抽出に戻す" width="80" centered>
                <a @click="returnData(props.row.receiptNumber)">
                  <b-icon icon="file-undo-outline" size="is-medium"></b-icon>
                </a>
              </b-table-column>
            </template>
          </b-table>
        </div>
        <div class="tableScroll-area" v-else>
          <b-table
            id="kenshinJudgmentOrderDetailListTable"
            :data="data.JudgmentRequestList"
            :paginated="true"
            per-page="10"
            pagination-position="both"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column field="receiptNumber" label="受付番号" width="120" sortable centered>
                <router-link :to="{name:'KenshinJudgmentOrderDetailone', params:{targetNumber:targetNumber, searchParams:searchParams, companyName:data.companyName, data:props.row, model:modelName, isWP:isWP, isSimonJ:isSimonJ, version: data.version}}"><a>{{props.row.receiptNumber}}</a></router-link>
              </b-table-column>
              <b-table-column field="info" label="測定情報">
                <table class="innerTable">
                  <tr>
                    <th colspan="2">社員番号</th><th colspan="2">名前</th><th>性別</th><th>生年月日</th><th>年齢</th><th>身長</th><th>体重</th>
                  </tr>
                  <tr>
                    <td colspan="2">{{props.row.employeeNumber}}</td><td colspan="2">{{props.row.name}}</td><td>{{props.row.gender}}</td><td>{{props.row.birthday}}</td><td>{{props.row.age}}</td><td>{{props.row.height}}</td><td>{{props.row.weight}}</td>
                  </tr>
                  <tr>
                    <th>BMI</th><th>検査ID</th><th>開始日</th><th>開始時間</th><th>終了日</th><th>終了時間</th><th>測定時間</th><th>睡眠時間</th><th>ODI4</th>
                  </tr>
                  <tr>
                    <td>{{props.row.bmi}}</td><td>{{props.row.inspectionId}}</td><td>{{props.row.startDate}}</td><td>{{props.row.startTime}}</td><td>{{props.row.endDate}}</td><td>{{props.row.endTime}}</td><td>{{props.row.measurementTime}}</td><td>{{props.row.sleepTime}}</td><td>{{props.row.odi4}}</td>
                  </tr>
                  <tr>
                    <th>ODI3</th><th>ODI2</th><th>SPO2中央</th><th>SPO2最低</th><th>脈拍中央</th><th>&lt;90%時間</th><th>&lt;90%割合</th><th>セルフチェック</th>
                  </tr>
                  <tr>
                    <td>{{props.row.odi3}}</td><td>{{props.row.odi2}}</td><td>{{props.row.SPO2Center}}</td><td>{{props.row.SPO2Minimum}}</td><td>{{props.row.pulseAverage}}</td><td>{{props.row.lessThan90Time}}</td><td>{{props.row.lessThan90Ratio}}</td><td>{{props.row.selfCheck}}</td>
                  </tr>
                  <tr>
                    <td colspan="10">
                      <ul class="report-list">
                        <li v-for="(report,index) in props.row.reportList" :key="index"><a @click="downloadFile(report.fileAddress, report.fileId)"><b-icon icon="paperclip" />{{report.name}}</a></li>
                      </ul>
                    </td>
                  </tr>
                </table>
              </b-table-column>
              <b-table-column field="delete" label="抽出に戻す" width="80" centered>
                <a @click="returnData(props.row.receiptNumber)">
                  <b-icon icon="file-undo-outline" size="is-medium"></b-icon>
                </a>
              </b-table-column>
            </template>
          </b-table>
        </div>
        <div class="button-area">
          <b-button class="is-primary" @click="judgmentRequest">判定を依頼</b-button>
          <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";

export default {
  name: "KenshinJudgmentOrderDetailList",
  methods: {
    back: function () {
      this.$router.push({
        name: "KenshinJudgmentOrder",
        params: { searchConditions: this.searchParams },
      });
    },
    judgmentRequest: function() {
      var excuteApi = this.setKenshinJudgmentRequestPOST;
      var successCallBack = this.setKenshinJudgmentRequestPOSTSuccess;
      var errorCallBack = this.setKenshinJudgmentRequestPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinJudgmentRequestPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      var receiptNumber = obj.JudgmentRequestList.map(item => item.receiptNumber)
      return client.apis.internalKenshin.setKenshinJudgmentRequestPOST({
        body:{
          receiptNumber:receiptNumber,
          version:obj.version
        }
      });
    },
    setKenshinJudgmentRequestPOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setKenshinJudgmentRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    returnData: function(receiptNumber) {
      this.returnDataNumber = receiptNumber
      var excuteApi = this.setReturnKenshinDataExtractionPOST;
      var successCallBack = this.setReturnKenshinDataExtractionPOSTSuccess;
      var errorCallBack = this.setReturnKenshinDataExtractionPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setReturnKenshinDataExtractionPOST: function(client) {
      return client.apis.internalKenshin.setReturnKenshinDataExtractionPOST({
        body:{
          receiptNumber:this.returnDataNumber,
          version:this.data.version
        }
      });
    },
    setReturnKenshinDataExtractionPOSTSuccess: function(result) {
      this.showSuccess(result,this.doSearch());
      this.returnDataNumber = ""
    },
    setReturnKenshinDataExtractionPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.returnDataNumber = ""
    },
    doSearch: function() {
      var excuteApi = this.getKenshinJudgmentRequestContentsPOST;
      var successCallBack = this.getKenshinJudgmentRequestContentsPOSTSuccess;
      var errorCallBack = this.getKenshinJudgmentRequestContentsPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinJudgmentRequestContentsPOST: function(client) {
      return client.apis.internalKenshin.getKenshinJudgmentRequestContentsPOST({
        body:{
          receiptNumber:this.targetNumber,
          detailFlag:false
        }
      });
    },
    getKenshinJudgmentRequestContentsPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      var model = this.kenshinDeviceList.find(val => val.value == this.data.modelId)
      this.modelName = model ? model.label1 : ""
      this.isWP = false
      this.isSimonJ = false
      if(model && model.label1.indexOf("ウォッチパット") != -1){
        this.isWP = true
      }else if(model && model.label1.indexOf("サイモンJ") != -1){
        this.isSimonJ = true
      }
      if(this.data.JudgmentRequestList.length == 0){
        this.back();
      }
      this.renderKey = !this.renderKey
    },
    getKenshinJudgmentRequestContentsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
                a.target="_blank"
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
    }
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var searchParams = this.$route.params["searchConditions"];
    var kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    return {
      targetNumber,
      searchParams,
      data: [],
      returnDataNumber:"",
      isWP:false,
      isSimonJ:false,
      kenshinDeviceList,
      modelName:"",
      renderKey:false
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.doSearch();
  },
  filters: {},
  components: {
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.tableScroll-area {
  max-height: 650px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.innerTable tr,
.innerTable th,
.innerTable td {
  height: 100%;
  border: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinJudgmentOrderDetailList.vue